// extracted by mini-css-extract-plugin
export var actionButton = "_8w-1";
export var actionButtons = "_8w-2";
export var actions = "_8w-0";
export var aiUnread = "_8w-10";
export var alignCenter = "_8w-h";
export var backWrapper = "_8w-3";
export var cellContainer = "_8w-4";
export var checkboxContainer = "_8w-5";
export var contentContainer = "_8w-6";
export var contentHeader = "_8w-8";
export var conversationsTableWrapper = "_8w-s";
export var draftReplyBadgeContainer = "_8w-m";
export var dropdownItem = "_8w-b";
export var dropdownItemsContainer = "_8w-a";
export var dropdownTitle = "_8w-c";
export var errorIcon = "_8w-7";
export var filter = "_8w-d";
export var gray = "_8w-i";
export var headerActionButtons = "_8w-e";
export var headerCheckboxContainer = "_8w-f";
export var icon = "_8w-j";
export var menuContainer = "_8w-k";
export var noMoreTicketsIcon = "_8w-12";
export var noMoreTicketsSubText = "_8w-13";
export var oneLine = "_8w-l";
export var optionsButton = "_8w-n";
export var plus = "_8w-o";
export var portalButtonsWrapper = "_8w-g";
export var red = "_8w-p";
export var scrolledTop = "_8w-9";
export var search = "_8w-q";
export var selectedConversationsCount = "_8w-r";
export var spinner = "_8w-t";
export var strong = "_8w-u";
export var summaryCell = "_8w-v";
export var tableContainer = "_8w-11";
export var tagContainer = "_8w-w";
export var threeDots = "_8w-x";
export var twoLines = "_8w-y";
export var unread = "_8w-z";